export default __webpack_public_path__ + "static/28-1c83b55d3fc3c4fa72a464b363e49b01.jpg";